import { createUseStyles } from 'react-jss';
import { SpacingsValues } from '@picsart/cascade';

import { mediaQuery } from '../../../styles/helpers';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      marginBottom: 40,
      marginInline: 'auto',
      maxWidth: 'min(100%, 648px)',
      paddingBlock: SpacingsValues.s56,

      [mediaQuery(breakpoints.tablet)]: {
        marginBottom: 0,
        paddingInline: SpacingsValues.s24,
      },
      [mediaQuery(breakpoints.mobile)]: {
        paddingBlock: SpacingsValues.s40,
      },
    },
    title: {
      fontSize: 42,
      fontWeight: 500,
      lineHeight: '50px',
      marginBottom: SpacingsValues.s40,
      textAlign: 'center',

      [mediaQuery(breakpoints.mobile)]: {
        fontSize: 30,
        lineHeight: '36px',
        marginBottom: SpacingsValues.s24,
      },
    },
    lst: {
      listStyleType: 'none',
    },
  }),
  {
    name: 'MinimalFaq',
  },
);

export default useStyles;
